import { clsx } from "clsx";
import { type CSSProperties, type FC, type PropsWithChildren, useEffect, useRef, useState } from "react";

import { useResizeObserver } from "../../hooks.ts";
import style from "./Collapse.module.css";

export interface CollapseProps {
  isExpanded?: boolean;
  className?: string;
  style?: CSSProperties;
  unmountOnExit?: boolean;
}

export const Collapse: FC<PropsWithChildren<CollapseProps>> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  const resizeRef = useRef<HTMLDivElement>(null);
  const resize = useResizeObserver(resizeRef);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(props.isExpanded ? (resize?.scrollHeight ?? ref.current?.scrollHeight ?? 0) : 0);
  }, [props.isExpanded, resize]);

  return (
    <div
      className={clsx(style.collapse, props.className, { [style.expanded]: props.isExpanded })}
      style={{ ...props.style, height }}
      ref={ref}
      data-testid={"collapse"}
    >
      <div
        ref={resizeRef}
        data-testid={`collapse-content-${props.isExpanded ? "expanded" : "collapsed"}`}
        className={style.list}
      >
        {props.unmountOnExit && !props.isExpanded ? null : props.children}
      </div>
    </div>
  );
};
